import React, { useEffect, useMemo, useState } from 'react';
import AppNavbar from '../Navbar/AppNavbar';
import Footer from '../Navbar/Footer';
import "../../assets/css/activity_page.scss"
import "../../assets/css/payment.scss"
import { useDispatch, useSelector } from 'react-redux';
import { Box, Chip, IconButton, Skeleton, Tooltip } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import { Circles } from 'react-loader-spinner';
import { useLocation } from 'react-router-dom';
import FilterBar from '../CommonFile/FilterBar';
import PageBreadcome from '../CommonFile/PageBreadcome';
import DataGridTable from '../CommonFile/DataGridTable';
import moment from 'moment';
import { sbnType } from '../CommonFile/DropdownValues';
import { loadPaymentData } from '../redux/paymentService/pmt_action';
import { getInitials } from '../CommonFile/Function_utils';
import { HistoryIcon } from 'lucide-react';
import HistoryModal from './HistoryModal';

function PaymentHistoryPage() {

    const dispatch = useDispatch();
    const location = useLocation();

    const { totalPages } = useSelector(state => state.sbndata);
    const { payment_data } = useSelector(state => state.paymentdata);
    const { totalDataCount } = useSelector(state => state.data);

    const [loadData, setLoadData] = useState(true)
    const [loadingMore, setLoadingMore] = useState(false)
    const [filterValues, setFilterValues] = useState({
        page: 1,
        page_size: 10,
        plan: "",
        search_text: "",
        from_date: null,
        to_date: null,
    })

    useEffect(() => {
        console.log(location, "location")
        if (location.state) {
            if (location.state?.sbn_type) {
                setFilterValues((prev) => ({
                    ...prev,
                    sbn_type: location.state?.sbn_type
                }));
            }
        }
    }, [location])

    useEffect(() => {
        const today = new Date();

        // First day of the current month
        const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
        );

        setFilterValues((prev) => ({
            ...prev,
            from_date: firstDayOfMonth,
            to_date: today,
        }));

        const filters = {
            ...filterValues,
            from_date: firstDayOfMonth,
            to_date: today,
        }

        setLoadData(true)
        pageLoadFunction(filters)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const pageLoadFunction = (filterValues) => {
        const params = {
            page: filterValues.page,
            page_size: filterValues.page_size,
            plan: filterValues.plan,
            search_text: filterValues.search_text,
            from_date: filterValues.from_date ? moment(filterValues.from_date).format("YYYY-MM-DD") : null,
            to_date: filterValues.to_date ? moment(filterValues.to_date).format("YYYY-MM-DD") : null,
        }

        dispatch(loadPaymentData(params)).then(
            (resp) => {
                setLoadData(false)
                setLoadingMore(false)
            }
        )
            .catch((err) => {
                setLoadingMore(false)
                setLoadData(false)
            });
    }


    const searchFunction = (filterValues) => {
        const filter = {
            ...filterValues,
            page: 1
        }
        setLoadingMore(true)
        setFilterValues(filter)
        pageLoadFunction(filter)
    }
    // , [filterValues])

    // #region fucntion for clear filters
    const clearFunction = () => {
        const today = new Date();

        const firstDayOfMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
        );

        const filter = {
            page: 1,
            page_size: 10,
            activity_type: "",
            search_text: "",
            from_date: firstDayOfMonth,
            to_date: today,
        }
        setLoadingMore(true)
        setFilterValues(filter)
        pageLoadFunction(filter);
    }
    // #endregion

    // region Define DataGrid columns
    const columns = useMemo(() => {
        const baseColumns = [
            {
                field: 'name', headerName: 'Name', flex: 1, minWidth: 200,
                renderCell: (params) => {
                    if (params.row.isSkeleton) {
                        return <Skeleton variant="text" width="80%" />
                    }

                    return (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',         // Creates a clean space between avatar and text
                            fontWeight: '600'
                        }}>
                            <span className="profile-avatar-table">
                                {params.value && getInitials(params.value.trim())}
                            </span>
                            <span>
                                {params.value ?? ""}
                            </span>
                        </div>
                    );
                }
            },
            {
                field: "email",
                headerName: "Email", flex: 1,
                minWidth: 200,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="90%" />
                    ) : (
                        <div className="activity-icon-sec">
                            <div className="activity-title">
                                <div>
                                    <span className="activity-email-bg">{params.value}</span>
                                </div>
                            </div>
                        </div>
                    ),
            },
            {
                field: "company_name",
                headerName: "Company", flex: 1,
                minWidth: 200,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="80%" />
                    ) : (
                        params.value || "-"
                    ),
            },
            {
                field: "total_amount",
                headerName: "Amount Purchased", flex: 1,
                minWidth: 200,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="95%" />
                    ) : (
                        <b>{params.value}</b>
                    ),
            },
            {
                field: "total_quantity",
                headerName: "Credits Purchased", flex: 1,
                minWidth: 120,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="60%" />
                    ) : (
                        <span className='text-blue'><b>{params.value}</b></span>
                    ),
            },
            {
                field: "latest_payment_date",
                headerName: "Last Purchased Date", flex: 1,
                minWidth: 200,
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="85%" />
                    ) : (
                        <Chip
                            label={moment(params.value).format("DD MMM YYYY • hh:mm A")}
                            size="small"
                            sx={{
                                fontWeight: 600,
                                backgroundColor: "var(--warning-bg-color)",
                                color: "var(--warning-color)",
                                border: "1px solid var(--warning-bg-color)",
                                borderRadius: "8px",
                            }}
                        />
                        // <b>{moment(params.value).format("DD MMM, YYYY - hh:mm A")}</b>
                    ),
            },
            {
                field: "action", // Note: It's good practice to give a unique field name (e.g., 'action')
                headerName: "Action",
                flex: 1,
                width: 80,
                headerAlign: "center", // Centers the header text
                align: "center",       // Centers the cell contents
                renderCell: (params) =>
                    params.row.isSkeleton ? (
                        <Skeleton variant="text" width="85%" />
                    ) : (
                        <Tooltip title="View History" arrow>
                            <IconButton
                                size="small"
                                sx={{
                                    bgcolor: "var(--purple-bg-color)",
                                    color: "var(--purple-color)",
                                    border: "1px solid #D8B4FE",
                                    fontWeight: 600,
                                    borderRadius: "8px",
                                    "& .MuiChip-label": {
                                        px: 1.5,
                                    },
                                }}
                                onClick={() => handleViewHistory(params.row)} // Your view history handler
                            >
                                <HistoryIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    ),
            }
        ];

        return baseColumns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // #region handle scroll
    useEffect(() => {
        const container = document.querySelector('.MuiDataGrid-virtualScroller');
        if (!container) return;

        let lastScrollTop = 0;

        const handleScroll = () => {
            if (!container || loadingMore) return;

            const currentScrollTop = container.scrollTop;

            if (currentScrollTop <= lastScrollTop) return;

            lastScrollTop = currentScrollTop;

            const distanceFromBottom = container.scrollHeight - currentScrollTop - container.clientHeight;

            if (distanceFromBottom === 0 && payment_data.length < totalDataCount && !loadingMore) {
                setLoadingMore(true);
                setFilterValues((prev) => {
                    if (prev.page >= totalPages) return prev;

                    return {
                        ...prev,
                        page: prev.page + 1,
                    };
                });
                const filter = {
                    ...filterValues,
                    page: filterValues.page + 1
                }
                pageLoadFunction(filter);
            }
        };

        container.addEventListener('scroll', handleScroll);

        // Cleanup function
        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingMore, payment_data, totalDataCount, setFilterValues]);
    // #endregion


    const handleFilterValues = (e) => {
        const { name, value } = e.target;

        setFilterValues((prev) => ({
            ...prev,
            [name]: value,
            page: 1,
        }));
    }

    const handleDateChange = (name, date) => {
        setFilterValues((prev) => {
            const updated = {
                ...prev,
                [name]: date,
                page: 1,
            };

            // If From Date is cleared, clear To Date as well
            if (name === "from_date" && !date) {
                updated.to_date = null;
            }

            // If From Date changes and To Date is before it, clear To Date
            if (
                name === "from_date" &&
                date &&
                updated.to_date &&
                updated.to_date < date
            ) {
                updated.to_date = null;
            }

            return updated;
        });
    };

    // #region view history data page
    const [historyModal, setHistoryModal] = useState(false);
    const [userId, setUserId] = useState(0);

    const handleViewHistory = (row) => {
        setHistoryModal(true)
        setUserId(row.user_id)
    }
    // #endregion

    // console.log(filterValues, "filterValues")

    const dataRows = loadData
        ? Array.from({ length: 12 }, (_, index) => ({
            id: `skeleton-${index}`, // unique key
            isSkeleton: true,
        }))
        : payment_data.map((row, index) => ({
            ...row,
            id: row.id ?? row.activity_id ?? `row-${index}`, // unique key for real rows
        }));

    return (
        <div className="page-layout" style={{ position: "relative" }}>

            <AppNavbar />
            <div className="page-content" style={{ overflow: "auto" }}>
                {historyModal && <HistoryModal show={historyModal}
                    user_id={userId} filterValues={filterValues}
                    setHistoryModal={setHistoryModal} />}
                <div className='subcription-main-page'>
                    <div className="subscription-page">

                        <div>
                            <PageBreadcome heading="Payment History"
                                sub_heading="View and track user payment transactions and revenue history." />
                        </div>

                        <div>
                            <FilterBar filterValues={filterValues}
                                handleFilterValues={handleFilterValues}
                                handleDateChange={handleDateChange} displayPage="Payment"
                                searchFunction={() => searchFunction(filterValues)} clearFunction={clearFunction}
                                select_type="plan" select_values={sbnType} />
                        </div>

                        <div className="subscription-content">
                            {/* <RecentActivityCard displayData={payment_data} /> */}
                            {/* Table comes here */}
                            <Box sx={{ width: '100%', mt: 2 }}>
                                <DataGridTable rowData={dataRows}
                                    columns={columns} height="585px !important"
                                    page="activity"
                                />
                                {(loadingMore) && <div className='loader-css'>
                                    <div className="d-flex justify-content-center align-items-center py-4">
                                        <Circles
                                            height="30"
                                            width="30"
                                            color="#007bff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        />
                                    </div>
                                </div>}
                            </Box>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default PaymentHistoryPage;
